import { css } from '@emotion/core'

export const styles = {
  container: css`
    width: 100%;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;

    text-transform: uppercase;
    font-size: 12px;
    color: rgb(150, 150, 150);
  `,
}
